export var PRIMARY_COLOR = '#0070ba';
export var PRIMARY_COLOR_V2 = '#003087';
export var SECONDARY_COLOR = '#e4f1fb';
export var ERROR_COLOR = '#d20000';
export var WARNING_COLOR = '#d64003';
export var WHITE_COLOR = '#ffffff';
export var OFF_WHITE_COLOR = '#f1ede8';
export var WARN_COLOR = '#ff9600';
export var BUTTON_FOCUSED_COLOR = '#005ea6';
export var BUTTON_BACK_MERCHANT_BACKGROUND_COLOR = '#E1E7EB';
export var BUTTON_BACK_MERCHANT_TEXT_COLOR = '#2c2e2f';
export var BORDER_COLOR = '#cbd2d6';
export var FUNDING_SOURCE_LOGO_BORDER_COLOR = '#ebebeb';
export var SEPARATOR_BORDER_COLOR = '#eaeced';
export var INPUT_BORDER_COLOR = '#b7bcbf';
export var INPUT_BORDER_COLOR_PP = '#929496';
export var INPUT_PP_REACT_FOCUSED_COLOR = '#0070E0';
export var INPUT_BORDER_FOCUSED_COLOR = '#009cde';
export var INPUT_BORDER_FOCUSED_COLOR_LIGHT = 'rgba(0, 156, 222, 10%)';
export var INPUT_TEXT_COLOR = '#2c2e2f';
export var LABEL_COLOR = '#6c7378';
export var INPUT_TEXT_BLUE_COLOR = '#0070E0';
export var ERROR_MESSAGE_BACKGROUND_COLOR = '#fff7f7';
export var INFO_MESSAGE_BACKGROUND_COLOR = '#f5f7fa';
export var SUCCESS_MESSAGE_BACKGROUND_COLOR = '#f5fdfb';
export var WARN_MESSAGE_BACKGROUND_COLOR = '#fffbf5';
export var TEXT_DEFAULT_COLOR = '#7e8489';
export var TEXT_HEADING_COLOR = '#4a4a4a';
export var TEXT_LIGHT_GRAY_COLOR = '#687173';
export var TEXT_GRAY_COLOR = '#545D68';
export var TEXT_GREEN_COLOR = '#388C00';
export var TEXT_DARK_BLUE_COLOR = '#001435';
export var IMAGE_BACKGROUND_COLOR = '#f8f8f8';
export var IMAGE_BORDER_COLOR = '#b0b8c5';
export var PP_LABEL_COLOR = '#545D68';
export var TOOLTIP_BACKGROUND_COLOR = '#f5fbfe';
export var TOOLTIP_BORDER_COLOR = '#50c7f9';
export var BANNER_BACKGROUND_COLOR = '#F0F4F5';
export var PAYPAL_FONT = "'PayPal Sans Big', 'Helvetica Neue', Helvetica, Arial, Roboto, sans-serif";
export var HELVETICA_FONT = "'Helvetica Neue', Helvetica, Arial, Roboto, sans-serif";